import React from 'react'
import PropTypes from 'prop-types'
import { Container, Heading } from '@scentregroup/ui'
import style from './index.scss'

const PageHeading = ({ title }) => (
  <Container type="large" className={style.heading}>
    <Heading type="extralarge">{title}</Heading>
  </Container>
)

PageHeading.propTypes = {
  title: PropTypes.string.isRequired,
}

export default PageHeading
